<template>

    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner :admin="false" />
    </b-container>

    <b-container v-else> 
        <div class="container-form-answer">

            <div class="single-question">

                <!-- Status -->
                <div class="single-question-top" style="height: 20px">
                    <div :class="entity.Question.StatusClass">
                        <span>{{entity.Question.StatusText}}</span>
                    </div>
                </div>

                <!-- Title with buttons -->
                <b-row class="m-30-0">

                    <b-col md="10" class="p-0 select-title medium">
                        {{entity.Question.Name}}
                    </b-col>

                    <b-col class="p-0">

                        <b-row class="h-end mb-5px" v-if="showTaskButton == 'true'">

                            <router-link :to="createTodoLink + `?tradePointId=${entity.TradePoint.Id}&formId=${formId}&auditId=${auditId}`" 
                                         class="add-link medium">
                                <font-awesome-icon icon="plus-circle" color="#54A5F4" class="icon-add-plus"/>
                                Добавить задачу
                            </router-link>

                        </b-row>

                        <b-row class="m-0 h-end">

                            <a href="#" @click="showCommentModal" class="add-link medium mr-25">
                                <font-awesome-icon icon="plus-circle" color="#54A5F4" class="icon-add-plus"/>
                                Комментарий
                            </a>

                        </b-row>

                    </b-col>             

                    <input-modal placeholder="Комментарий к вопросу"
                                 v-model="entity.Question.Comment" />

                </b-row>

                <!-- Answer Is text -->
                <input v-if="entity.Question.IsText"
                       type="text"
                       v-model="answer.Value"
                       class="form-control"
                       @input="checkVisiblePolicy(answer)" />

                <!-- Answer Is number or percent -->
                <b-input v-if="entity.Question.IsNumber || entity.Question.IsPercent"
                       type="number"
                       number
                       v-model="answer.Value"
                       class="form-control"
                       @input="checkVisiblePolicy(answer)" />

                <!-- Answer Is Decimal -->
                <b-input v-if="entity.Question.IsDecimal"
                       type="number"
                       number
                       step="0.01"
                       v-model="answer.Value"
                       @input="checkVisiblePolicy(answer)"
                       class="form-control" />

                <!-- Answer Is Radio -->
                <div v-if="entity.Question.IsSelect || entity.Question.IsSmallSelect" class="radio">

                    <b-form-group>
                        <b-form-radio v-for="(item, index) in mainAnswerList" 
                                      :key="index" 
                                      v-model="entity.Question.Selected" 
                                      :value="item.Value.Key"
                                      @change="checkVisiblePolicy(answer)">
                            {{item.Value.Value}}
                        </b-form-radio>
                    </b-form-group>


                </div>

                <!-- Answer is Contact -->
                <custom-multiselect v-if="entity.Question.IsContact"
                                     track-by="Id"
                                     label="Fio"
                                     :options="contacts"
                                     v-model="answer.Value"
                                     placeholder="Выберите контакт"
                                     @select="checkVisiblePolicy(answer)"/>

                <!-- Answer is BoolSelect -->
                <yes-no-input v-if="entity.Question.IsBoolSelect"
                              v-model="answer.Value"
                              @click="checkVisiblePolicy(answer)" />

                <!-- Answer is Multiple select or AEP -->
                <div v-if="entity.Question.IsMultipleAnswer" class="isMultiple">
                    
                    <div v-if="!mainAnswerList.length" class="stub-bold"> 
                        В AEP нет ни одного SKU
                    </div>

                    <div v-if="mainAnswerList.length" >

                        <div v-for="(mainAnswer, index) in mainAnswerList" 
                                 :key="index">

                            <hr class="m-0" />

                            <b-row class="m-0 p-10-15">

                                <b-col md="7"
                                       class="p-0 v-center fs-16">
                                    {{mainAnswer.Value[entity.Question.getLabel()]}}
                                </b-col>

                                <b-col md="5" class="p-0">
                                    <yes-no-input v-model="mainAnswer.Selected"
                                                  :key="'q_' + index"
                                                  @click="checkVisiblePolicy(mainAnswer)" />
                                </b-col>
                                
                            </b-row>
                            <hr class="m-0" />

                            <!-- SubQuestion for AEP -->

                            <div v-if="mainAnswer.Selected != null" style="background-color: #eсeсeс;">
                                
                                <div v-for="(subQuestion, subIndex) in getVisibleSub(mainAnswer)"
                                    :key="subIndex">

                                    <hr class="m-0" />

                                    <b-row class="m-0 p-5-15">

                                        <b-col md="7"
                                               class="pr-10 v-center fs-16">
                                            {{subQuestion.Name}}
                                        </b-col>

                                        <b-col md="5" class="p-0 v-center">

                                            <b-input v-if="subQuestion.IsText"
                                                     :key="'q_' + index + '_sub_' + subIndex"                                                     
                                                     v-model="subQuestion.AnswerList[0].Value"
                                                     @input="checkVisiblePolicy(mainAnswer)"
                                                     type="text" />

                                            <b-input v-if="subQuestion.IsNumber"
                                                    :key="'q_' + index + '_sub_' + subIndex"                                                
                                                    v-model="subQuestion.AnswerList[0].Value"
                                                    type="number"
                                                    number
                                                    @input="checkVisiblePolicy(mainAnswer)"
                                                    :min="0" />

                                            <b-input v-if="subQuestion.IsPercent"
                                                    :key="'q_' + index + '_sub_' + subIndex"                                                
                                                    v-model="subQuestion.AnswerList[0].Value"
                                                    type="number"
                                                    number
                                                    :min="0"
                                                    :max="100" 
                                                    @input="checkVisiblePolicy(mainAnswer)"/>

                                            <b-input v-if="subQuestion.IsDecimal"
                                                    :key="'q_' + index + '_sub_' + subIndex"                                                
                                                    v-model="subQuestion.AnswerList[0].Value"
                                                    number
                                                    step="0.01"
                                                    min="0"
                                                    type="number" 
                                                    @input="checkVisiblePolicy(mainAnswer)"/>
                                                
                                            <custom-multiselect v-if="subQuestion.IsContact"
                                                                track-by="Id"
                                                                label="Fio"
                                                                :options="contacts"
                                                                :key="'q_' + index + '_sub_' + subIndex"
                                                                v-model="subQuestion.AnswerList[0].Value"
                                                                placeholder="Выберите контакт" 
                                                                @select="checkVisiblePolicy(mainAnswer)" />
                                            
                                            <yes-no-input v-if="subQuestion.IsBoolSelect"
                                                          :key="'q_' + index + '_sub_' + subIndex"
                                                          class="m-0"
                                                          v-model="subQuestion.AnswerList[0].Value"
                                                          @click="checkVisiblePolicy(mainAnswer)" />

                                            <custom-multiselect v-if="subQuestion.IsSelect || subQuestion.IsSmallSelect || subQuestion.IsMultipleSelect || subQuestion.IsAep"
                                                                :track-by="subQuestion.getTrackBy()"
                                                                :label="subQuestion.getLabel()"
                                                                :id="subQuestion.Id"
                                                                :options="subQuestion.Options"
                                                                v-model="subQuestion.Selected"
                                                                :multiple="subQuestion.IsMultipleSelect || subQuestion.IsAep"
                                                                @select="checkVisiblePolicy(mainAnswer)" />                                        
                                        </b-col>
                                    </b-row>
                                </div>
                            </div>

                        </div>
                    </div>
                    
                </div>
                
            </div>


            <!-- Sub questions block (if !Main.IsMultipleAnswer) -->
	        <div v-if="entity.Question.IsBlockSubQuestions">    
                <hr class="m-0" />

                <div class="head-related-questions">
                    <span :class="showSubUnderMain ? 'active-arrow' : ''">
                        &#11166;
                    </span>
                    <span class="align-middle">
                        Связанные вопросы
                    </span>
                </div>

                <hr class="m-0" />

                <div v-if="showSubUnderMain">
                    <div v-for="(subQuestion, index) in getVisibleSub()" :key="index">

                        <hr class="m-0" />

                        <b-row class="m-0 p-10-22">

                            <b-col md="7"
                                   class="p-0 v-center fs-16">
                                {{subQuestion.Name}}
                            </b-col>

                            <b-col md="5" class="p-0 v-center">

                                <b-input v-if="subQuestion.IsText"                                        
                                        v-model="subQuestion.AnswerList[0].Value"
                                        type="text"
                                        @input="checkVisiblePolicy(answer)" />

                                <b-input v-if="subQuestion.IsNumber"                                        
                                        v-model="subQuestion.AnswerList[0].Value"
                                        type="number"
                                        number
                                        :min="0"
                                        @input="checkVisiblePolicy(answer)" />

                                <b-input v-if="subQuestion.IsPercent"                                        
                                        v-model="subQuestion.AnswerList[0].Value"
                                        type="number"
                                        number
                                        :min="0"
                                        :max="100"
                                        @input="checkVisiblePolicy(answer)" />

                                <b-input v-if="subQuestion.IsDecimal"                                        
                                        v-model="subQuestion.AnswerList[0].Value"
                                        step="0.01"
                                        min="0"
                                        type="number"
                                        number
                                        @input="checkVisiblePolicy(answer)" />

                                <custom-multiselect v-if="subQuestion.IsContact"
                                                    track-by="Id"
                                                    label="Fio"
                                                    :options="contacts"
                                                    v-model="subQuestion.AnswerList[0].Value"
                                                    placeholder="Выберите контакт"
                                                    @select="checkVisiblePolicy(answer)" />

                                <custom-multiselect v-if="subQuestion.IsSelect || subQuestion.IsSmallSelect || subQuestion.IsMultipleSelect || subQuestion.IsAep"
                                                    :track-by="subQuestion.getTrackBy()"
                                                    :label="subQuestion.getLabel()"
                                                    :id="subQuestion.Id"
                                                    :options="subQuestion.Options"
                                                    v-model="subQuestion.Selected"
                                                    :multiple="subQuestion.IsMultipleSelect || subQuestion.IsAep"
                                                    @select="checkVisiblePolicy(answer)" />

                                <yes-no-input v-if="subQuestion.IsBoolSelect"
                                              class="m-0"
                                              v-model="subQuestion.AnswerList[0].Value"
                                              @click="checkVisiblePolicy(answer)" />

                            </b-col>
                        </b-row>
                    </div>
                </div>

                <hr class="m-0" />
            </div>

            <div class="main-input-nav">
                <b-button variant="outline-primary" 
                          class="button-blue mr-5px"
                          :disabled="entity.IsReadOnly"
                          @click="save(false)">
                    <font-awesome-icon icon="arrow-left"/>
                    Назад
                </b-button>

                <b-button variant="outline-primary" 
                          class="button-blue ml-5px"
                          :disabled="entity.IsReadOnly"
                          @click="save(true)">
                    Дальше
                    <font-awesome-icon icon="arrow-right"/>
                </b-button>
	        </div>

        </div>

    </b-container>

</template>
<script>
import '@/assets/styles/client/form/formAnswer.css'

import apiService from '@/services/api.service'
import dialogSevice from '@/services/dialog.service'
import visiblePolicyService from '@/services/visiblePolicy.service'

import AllRoutes from '@/routes/all.routes'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import YesNoInput from '@/components/shared/YesNoInput'
import InputModal from '@/components/shared/InputModal'
import CustomMultiselect from '@/components/shared/CustomMultiSelect'

import FormAnswerModel from '@/store/models/client/form/FormAnswer'

export default {
    data: function() {
        let load = new Loading();
        load.Calculate(true);
        this.getAnswer(load, this.$route.query.questionId);

        return {
            load: load,
            entity: new FormAnswerModel(),
            contacts: [],

            auditId: this.$route.query.auditId,
            formId: this.$route.query.formId,

            showTaskButton: this.$route.query.showTaskButton,

            createTodoLink: AllRoutes.Client.Form.CreateTask
        }

        
    },
    beforeRouteUpdate: function(to, from, next) {

        this.getAnswer(this.load, to.query.questionId);

        next();
    },
    methods: {
        getAnswer: function(load, questionId) {

            apiService.Client.Form.GetQuestion(this.$route.query.auditId, this.$route.query.formId, questionId)
                .then(response => {      
                    this.entity = new FormAnswerModel().mapFromDto(response.data);

                    if (this.entity.Question.IsContact || this.entity.Question.AnswerList.some(a => a.SubQuestionList.some(q => q.IsContact)))
                        this.getContacts();
                    
                    this.entity.Question.AnswerList.forEach(mainAnswer => {
                        this.checkVisiblePolicy(mainAnswer);
                    });

                    if(this.entity.IsReadOnly)
                        dialogSevice.showAlert('Предупреждение', 'Завершенные анкеты невозможно изменять.')

                    load.Calculate(false);
                })
                .catch(() => load.Calculate(false));
        },

        getSubAnswerValue(questionId) {
				var subAnswer = this.entity.SubAnswers.find(q => q.QuestionId === questionId);
				return subAnswer.Values[0];
		},

        getContacts() {
            this.load.Calculate(true);
            apiService.Client.Audit.GetDaxUsers()
                .then(response => {
                    this.contacts = response.data;
                    this.load.Calculate(false);
                })
                .catch(() => this.load.Calculate(false));
        },

        getVisibleSub(mainAnswer) {
            if (mainAnswer != null) {
                return mainAnswer.SubQuestionList.filter(q => q.IsVisible);
            }

            return this.answer.SubQuestionList.filter(q => q.IsVisible);
        },

        save(isNext) {

            if(this.entity.IsReadOnly) 			
                return;
    
            var result = JSON.parse(JSON.stringify(this.entity.Question));

            result.Comment = result.Comment == "" ? null : result.Comment;
            
            if(result.IsBoolSelect)
                result.AnswerList[0].Selected = result.AnswerList[0].Value;

            result.AnswerList.forEach(ma => {
               
               ma.SubQuestionList.forEach(sq => {
                   
                   if(sq.IsBoolSelect) 
                       sq.AnswerList[0].Selected = sq.AnswerList[0].Value;

               });

            });            

            this.load.Calculate(true);

            apiService.Client.Form.PostQuestion(result, this.auditId, this.formId, isNext)
                .then(response => {			
                    if (response.data === 0) { 
                        this.$router.push(`${AllRoutes.Client.Form.Index}?auditId=${this.auditId}&id=${this.formId}`);
                    }
                    else if (response.data === -1) {
                        this.load.Calculate(false);	

                        dialogSevice.showConfirm('Подтверждение сохранения', 'Подтвердите сохранение ответов на вопросы Магнита. Внимание! После этого нельзя изменять ответы во вкладке МАГНИТ.')
                        .then(() => {
                            this.finishWorkQuestionMagnit();
                        })
                        .catch(() => { });
                    }
                    else {
                        this.load.Calculate(false);
                        this.$router.push(`${AllRoutes.Client.Form.Answer}?auditId=${this.auditId}&formId=${this.formId}&questionId=${response.data}`);
                    }	                                        
                })
                .catch(() => this.load.Calculate(false));
        },

        finishWorkQuestionMagnit: function() {
            apiService.Client.Form.PostConfirmMagnit(this.auditId, this.formId)
                .then(() => {
                    this.$router.push(`${AllRoutes.Client.Form.Index}?auditId=${this.auditId}&id=${this.formId}`);
                })
                .catch(error => {
                    dialogSevice.showAlert('Ошибка', error.response.data);
                    console.error(error);
                });
        },

        showCommentModal: function() {
            this.$modal.show('input-modal');
        },

        checkVisiblePolicy: function(mainAnswer) {
            if (this.entity.Question.IsSelect || this.entity.Question.IsSmallSelect) {
                this.$nextTick(() => {
                if (!Boolean(this.answer))
                    return;

                this.answer.SubQuestionList.forEach(subQuestion => {
                    subQuestion.IsVisible =  
                        visiblePolicyService.checkVisible(subQuestion, this.answer, this.entity.Question, this.entity.TradePoint);
                });
                })
            } else {
                mainAnswer.SubQuestionList.forEach(subQuestion => {
                    subQuestion.IsVisible =  
                        visiblePolicyService.checkVisible(subQuestion, mainAnswer, this.entity.Question, this.entity.TradePoint);
                });
            }
        }
    },
    computed: {
        radioSelected: {
            get: function() {
                let selected = this.entity.Question.AnswerList.find(e => Boolean(e.Selected));

                return Boolean(selected) ? selected.Value.Key : null;  
            },
            set: function(key) {
                this.entity.Question.AnswerList.forEach(e => { 
                    if(key == e.Value.Key)
                        e.Selected = true;
                    else
                        e.Selected = null 
                });            
            }
        },
        answer: {
            get: function () {
                //if (this.entity.Question.IsMultipleAnswer)
                    //dialogSevice.showAlert('Ошибка', 'Вызов одиночного ответа в множественном. Бага((');
                
                if(this.entity.Question.AnswerType == 20 || this.entity.Question.AnswerType == 22)
                    return this.entity.Question.AnswerList.find(e => Boolean(e.Selected));

                return this.entity.Question.AnswerList[0];
            }
        },
        multipleAnswer: {
            get: function () {
                // if (!this.entity.Question.IsMultipleAnswer)
                //     dialogSevice.showAlert('Ошибка', 'Вызов множественного ответа в одиночном. Бага((');

                return this.entity.MainAnswers.Values;
            }
        },
        mainAnswerList: function() {
            return this.entity.Question.AnswerList;
        },
        showSubUnderMain: function () {
            return this.entity.Question.IsBlockSubQuestions && 
                   Boolean(this.answer) &&
                   this.answer.Value !== "" && this.answer.Value !== null;
        }
    },
    components: {
        Spinner,
        YesNoInput,
        InputModal,
        CustomMultiselect
    }
}
</script>